module.exports = __webpack_public_path__ + "media/v2/components/HowToPlay/img/2_step-e28f5feb816aebfff20b259570e6a4f3.jpg";